import type { ReactNode } from 'react';

import { visuallyHidden } from '../../styles';

export interface AccessibleContentProps {
  /** Visible text that should not be read by screen readers. */
  visualContent?: ReactNode;
  /**
   * Text that is not visually visible but is included in the accessibility
   * tree.
   */
  accessibleText: string;
}
/**
 * Render textual content not visible in the accessible tree along with text to
 * replace it.
 *
 * @deprecated Use either `visuallyHidden` class or `aria-hidden` attribute
 *   directly.
 * @see https://corgi-x.tfd.engineering/api/variables/visuallyHidden
 * @see https://corgi-x.tfd.engineering/components/accessiblecontent
 */
export function AccessibleContent(props: AccessibleContentProps): JSX.Element {
  return (
    <>
      <div aria-hidden="true">{props.visualContent}</div>
      <span className={visuallyHidden}>{props.accessibleText}</span>
    </>
  );
}
